import { useCallback } from 'react';
import { SelectChangeEvent } from '@mui/material';
import { SelectOne, SelectOneProps } from '../../SelectOne/SelectOne.component';
import { blockIconForInput } from '../../EditSession/BlockItemForInput';
import { ToleranceRangeRow } from '../../../pages/Sessions/SessionsParametersDialog/ToleranceRange/ToleranceRange.types';

interface InputSelectionProps<T> {
  idRow: string | number;
  rowKey: keyof T;
  handleValueChange: (key: keyof T, value: number | boolean | null, id: string | number) => void;
  validation?: (row: T, key: keyof T) => boolean;
  row: T;
  value: string | number;
  inputLabel: string;
  ariaLabel: string
}

type ExtendedInputSelectionProps<T> = InputSelectionProps<T> & SelectOneProps;

export const InputSelection = <T,>(props: any) => {
  const InputTextFieldProps = ['rowKey', 'validation', 'isValid', 'row', 'handleValueChange', 'idRow', 'value', 'ariaLabel'];
  const filterProps = Object.entries(props).filter((x) => !InputTextFieldProps.includes(x[0]));
  const convertedProps = Object.fromEntries(filterProps);

  const onValueChange = useCallback(
    (event: SelectChangeEvent<unknown>) => {
      const val = event.target.value as number;
      props.handleValueChange(props.rowKey, val, props.idRow);
      if (props.validation) {
        props.validation(props.row, props.rowKey);
      }
    },
    [props.rowKey, props.row, props.handleValueChange],
  );

  return (
    <SelectOne
      {...convertedProps}
      items={props.items}
      inputLabel={props.inputLabel}
      ariaLabel={props.ariaLabel}
      value={props.value}
      onChange={onValueChange}
      startAdornment= {blockIconForInput(props.disabled, {marginRight:'0px'})}
    />
  );
};
